import {
    apiRequest,
    bobotKomponenPenilaianList,
    bobotKomponenPenilaianActive,
    bobotKomponenPenilaianInactive,
} from "../../../../../../services/adapters/master/bobotKomponenPenilaianService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", bobotKomponenPenilaianList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", bobotKomponenPenilaianInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", bobotKomponenPenilaianActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository